import { type MaybeRefOrGetter, onBeforeMount, onBeforeUnmount, toValue, watch } from 'vue'

import type { PortalAdTargeting } from '@/modules/adv/types'
import { useAdsStore } from '@/store/ads-store'

export const useScopedAdTargeting = (targeting: MaybeRefOrGetter<PortalAdTargeting | undefined>) => {
    const adsStore = useAdsStore()
    const ownedKeys = new Set<string>()

    const apply = (value: PortalAdTargeting | undefined) => {
        if (!value) {
            return
        }
        Object.keys(value).forEach((key) => ownedKeys.add(key))
        adsStore.updateTargeting(value)
    }

    // oxlint-disable-next-line playgama/no-on-before-mount
    onBeforeMount(() => apply(toValue(targeting)))

    watch(() => toValue(targeting), apply)

    onBeforeUnmount(() => {
        adsStore.updateTargeting(Object.fromEntries([...ownedKeys].map((key) => [key, ''])))
    })
}
